import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../../utils/customBaseQuery';

export const promoApi = createApi({
  reducerPath: 'promoApi',
  baseQuery: customBaseQuery,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({

    // POST — создать промокод
    createPromo: builder.mutation({
      query: (data) => ({
        url: '/create',
        method: 'POST',
        body: data,
        prefix: 'promo',
      }),
    }),

    // GET — получить все промокоды
    allPromos: builder.query({
      query: (code) => ({
        url: `/all`,
        params: { code },
        method: 'GET',
        prefix: 'promo',
      }),
    }),

    // PUT — обновить промокод по id
    updatePromo: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
        prefix: 'promo',
      }),
    }),

    // DELETE — удалить промокод по id
    deletePromo: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: 'DELETE',
        prefix: 'promo',
      }),
    }),

    // POST — активировать промокод пользователем
    activatePromo: builder.mutation({
      query: (data) => ({
        url: '/activate',
        method: 'POST',
        body: data,
        prefix: 'promo',
      }),
    }),

    // GET — получить количество активаций по promoId
    getPromoActivations: builder.query({
      query: (id) => ({
        url: `/${id}/activations`,
        method: 'GET',
        prefix: 'promo',
      }),
    }),

  }),
});

export const {
  useCreatePromoMutation,
  useAllPromosQuery,
  useLazyAllPromosQuery,
  useUpdatePromoMutation,
  useDeletePromoMutation,
  useActivatePromoMutation,
  useGetPromoActivationsQuery,
  useLazyGetPromoActivationsQuery,
} = promoApi;
